import { ReactNode, useRef } from "react";
import { AuthView } from "@daveyplate/better-auth-ui";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface AuthDialogModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: ReactNode;
  description?: ReactNode;
  authPath: "sign-in" | "sign-up";
  redirectTo?: string;
}

export function AuthDialogModal({
  open,
  onOpenChange,
  title,
  description,
  authPath,
  redirectTo,
}: AuthDialogModalProps) {
  const openerRef = useRef<HTMLElement | null>(null);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="sm:max-w-[425px] !bg-white !text-slate-900"
        data-auth-modal="true"
        tabIndex={-1}
        onOpenAutoFocus={(event) => {
          event.preventDefault();
          openerRef.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
          const dialog = event.currentTarget as HTMLElement;
          if (dialog) {
            dialog.focus({ preventScroll: true });
          }
        }}
        onCloseAutoFocus={(event) => {
          if (openerRef.current?.isConnected) {
            event.preventDefault();
            openerRef.current.focus({ preventScroll: true });
          }
        }}
      >
        <DialogHeader>
          <DialogTitle className="mb-4">{title}</DialogTitle>
          {description ? <DialogDescription>{description}</DialogDescription> : null}
        </DialogHeader>
        <div className="mt-2">
          <AuthView path={authPath} redirectTo={redirectTo} />
        </div>
      </DialogContent>
    </Dialog>
  );
}

